import typeToReducer from "type-to-reducer";
import { fromJS } from "immutable";

const initialState = fromJS({});

export default typeToReducer({}, initialState);
